const Constants = {
  drawerWidth: 240
}

export default Constants



// WEBPACK FOOTER //
// ./src/shared/utils/Contants.js